<template>
  <div class="container-fluid">
    <div class="row customer-forms">
      <div class="col-xs-12 col-md-6 customer-forms__column customer-forms__column--first">
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <customer-form-complex
              class="customer-forms__form"
              @validation-failed="handleValidationFailed"
              @validation-successful="handleValidationSuccess"
            />
          </div>
        </div>
      </div>
      <div
        v-if="showBetweenText"
        class="customer-forms__between-text"
      >
        or
      </div>
      <div class="col-xs-12 col-md-6 customer-forms__column customer-forms__column--second">
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <customer-form-simple
              class="customer-forms__form"
              @validation-failed="handleValidationFailed"
              @validation-successful="handleValidationSuccess"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerFormComplex from './CustomerFormComplex.vue'
import CustomerFormSimple from './CustomerFormSimple.vue'

export default {
  name: 'CustomerForms',
  components: {
    CustomerFormComplex,
    CustomerFormSimple
  },
  data () {
    return {
      showBetweenText: true
    }
  },
  methods: {
    handleValidationFailed () {
      this.showBetweenText = false
    },
    handleValidationSuccess () {
      this.showBetweenText = true
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-forms {
  position: relative;

  &__column {
    &--first {
      background-color: #37546f;
    }

    &--second {
      background-color: #7090ad;
    }
  }

  &__between-text {
    background: white;
    border-radius: 50%;
    color: #000;
    font-weight: bold;
    height: 33px;
    left: 48.7%;
    padding: 0.35rem 0 0 0;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    top: 47%;
    width: 33px;
    z-index: 2;

    @media screen and (min-width: $screen-sm-min) {
      top: 39%;
    }

    @media screen and (min-width: $screen-md-min) {
      top: 36%;
    }

    @media screen and (min-width: 1600px) {
      left: 49%;
    }

    @media screen and (min-width: 2200px) {
      left: 49.25%;
    }
  }

  &__form {
    margin: 2rem 0;

    @media screen and (min-width: $screen-md-min) {
      margin: 4rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/home/index/components/CustomerForms/CustomerForms.vue